import { render, staticRenderFns } from "./BlindBoxDetail.vue?vue&type=template&id=3301a6f8&scoped=true"
import script from "./BlindBoxDetail.vue?vue&type=script&lang=js"
export * from "./BlindBoxDetail.vue?vue&type=script&lang=js"
import style0 from "./BlindBoxDetail.vue?vue&type=style&index=0&id=3301a6f8&prod&lang=scss&scoped=true"
import style1 from "./BlindBoxDetail.vue?vue&type=style&index=1&id=3301a6f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3301a6f8",
  null
  
)

export default component.exports